import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, TextField, Button } from "@material-ui/core";
import { useSnackbar } from "notistack";
import { redeemCode } from "../api";
import GenericContainer from "../../../components/containers/GenericContainer";

const useStyles = makeStyles((theme) => ({
  header: {
    fontWeight: 400,
    margin: theme.spacing(1, 0, 1),
  },
  form: {
    display: "flex",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  input: {
    flex: 1,
  },
}));

const CodeRedemption = ({ onRedeem }) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) {
      enqueueSnackbar("Please enter a code", { variant: "error" });
      return;
    }

    setLoading(true);
    try {
      const response = await redeemCode(code.trim());
      enqueueSnackbar(response.data.message || "Code redeemed successfully!", {
        variant: "success",
      });
      setCode("");
      if (onRedeem) onRedeem();
    } catch (error) {
      enqueueSnackbar(error.response?.data?.error || "Failed to redeem code", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <GenericContainer>
      <Typography variant="h5" className={classes.header}>
        Redeem Code
      </Typography>
      <form onSubmit={handleSubmit} className={classes.form}>
        <TextField
          className={classes.input}
          label="Enter Code"
          variant="outlined"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          disabled={loading}
          placeholder="Enter your redemption code"
        />
        <Button type="submit" variant="contained" color="primary" disabled={loading}>
          Redeem
        </Button>
      </form>
    </GenericContainer>
  );
};

export default CodeRedemption;
